export default "__VITE_ASSET__CwGzbUpl__"